import { useQueryClient } from 'react-query';

import { useMutationTestNarrativeText } from 'api/mutations/testNarrativeText.mutation';
import { useMutationUpdateTemplateText } from 'api/mutations/updateTemplateText.mutation';
import { useQueryGetComponentLiteList } from 'api/queries/getComponentLiteList';
import { useQueryGetTemplateByKey } from 'api/queries/getTemplateByKey';

import { useGetCurrentFocusedProjectData } from 'components/Settings/Components/NarrativeTemplates/components/NarrativeTemplates/_hooks/useGetCurrentFocusedProjectData';

export const useNarrativeTemplatesProvider = (componentFromForm: ISelectOption<string> | undefined) => {
    const queryClient = useQueryClient();

    const { contract, project, latestVersion, baselineVersion } = useGetCurrentFocusedProjectData();
    const { data: componentList } = useQueryGetComponentLiteList();

    const { data: templateData } = useQueryGetTemplateByKey({
        componentKey: componentFromForm?.value,
        componentId: componentFromForm?.id as number,
    });

    const {
        mutate: mutateTestNarrativeText,
        data: testNarrativeTextApiResponse,
        isLoading: isNarrativeTestLoading,
    } = useMutationTestNarrativeText();

    const { mutate: updateTemplateText, isLoading: isUpdatingTemplate } = useMutationUpdateTemplateText();

    return {
        queryData: {
            project: {
                contract,
                project,
                latestVersion,
                baselineVersion,
            },
            componentList,
            narrativeTemplatePerComponent: templateData,
        },
        queryMutations: {
            testNarrativeText: {
                mutate: mutateTestNarrativeText,
                data: testNarrativeTextApiResponse,
                isLoading: isNarrativeTestLoading,
            },
            updateTemplateText: {
                mutate: updateTemplateText,
                isLoading: isUpdatingTemplate,
            },
        },
        queryUtils: {
            queryClient,
        },
    };
};
